/**
 * 账号登录相关
 */
import api from '../../api/api'
import * as types from '../mutation'
import cookie from 'react-cookie'
import { MessageBox } from 'element-ui'
import { roleType } from './../../config/config.js'
import { routeMap } from './../../utils/com.js'
import CryptoJS from 'crypto-js'

// console.debug("login> routeMap:%o, CryptoJS:%o", routeMap, CryptoJS);

const state = {
  token: cookie.load('ibroadcasttoken') || null,
  account: cookie.load('ibroadcastaccount') || null,
  role: cookie.load('ibroadcastrole') || null,
  osspolicy: cookie.load('ibroadcastosspolicy') || null,
  osskeyid: cookie.load('ibroadcastosskeyid') || null,
  osssign: cookie.load('ibroadcastosssign') || null,
  /* appid */
  appid: cookie.load('ibroadcastappid') || null,
  accesstoken: cookie.load('ibroadcastaccesstoken') || null
}

const getters = {
  getToken: state => state.token,
  getAccount: state => state.account,
  getRole: state => state.role,
  getOsspolicy: state => state.osspolicy,
  getOsskeyid: state => state.osskeyid,
  getOsssign: state => state.osssign,
  /* appid */
  getAppid: state => state.appid,
  getAccesstoken: state => state.accesstoken
}

const actions = {
  /**
     * 用户登录
     */
  onLogin ({ commit, state, rootState }, that) {
    let param = that.form
    api.apiCommunication('/user/login', param, function (response) {
      // console.debug("onLogin> param:%o, response:%o", param, response);
      if (response.code !== 0) {
        MessageBox.alert(`登录失败，${response.msg}`, '系统通知', { confirmButtonText: '确定', type: 'error' })
        return false
      }
      // 设置cookie过期时间
      var exp = new Date()
      exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000)
      // 保存token
      cookie.save('ibroadcasttoken', response.data.token, {
        path: '/',
        expires: exp
      })
      cookie.save('ibroadcastaccount', param.name, {
        path: '/',
        expires: exp
      })
      cookie.save('ibroadcastrole', response.data.role, {
        path: '/',
        expires: exp
      })

      sessionStorage.setItem('userType', response.data.role)
      sessionStorage.setItem('userName', param.name)
      //   cookie.save('ibroadcastosspolicy', response.data.osspolicy, {
      //     path: '/',
      //     expires: exp
      //   })
      //   cookie.save('ibroadcastosskeyid', response.data.osskeyid, {
      //     path: '/',
      //     expires: exp
      //   })
      //   cookie.save('ibroadcastosssign', response.data.osssign, {
      //     path: '/',
      //     expires: exp
      //   })
      // 获取成功，提交mutations处理数据
      // console.debug("onLogin> param:%o", param);
      commit(types.USER_LOGIN_SUCCESS, { response, param })
      // 重定向销售概览页
      // console.info("onLogin> path:%o, params:%o, query:%o", rootState.route.path, rootState.route.params, rootState.route.query);
      // console.debug("onLogin> state:%o", state);
      // force user to visit user's role page in case of role is true
      let type = null
      if (state.role) {
        type = roleType[state.role]
      } else {
        // type = rootState.route.query.type || ''
        type = 'irecord'
      }
      console.log(state.role)
      that.$router.push({ path: routeMap('/' + type) })
    })
  },
  /**
     * 用户登录
     */
  AppIdLogin ({ commit, state, rootState }, that) {
    let param = {}
    param.appid = that.form.name
    let appsecret = that.form.password

    // 设置cookie过期时间
    var exp = new Date()

    let timestamp = Math.round(exp.getTime() / 60000)
    // console.debug("timestamp:%o", timestamp);
    let tempstr = param.appid + appsecret + timestamp
    let tmeptoken = CryptoJS.MD5(tempstr).toString()
    // console.debug("tempstr:%s, tmeptoken:%s", tempstr, tmeptoken);
    let accesstoken = (timestamp + tmeptoken).toUpperCase()
    // console.debug("accesstoken:%o", accesstoken);
    param.accesstoken = accesstoken
    // console.debug("AppIdLogin> param:%o", param);

    exp.setTime(exp.getTime() + 1 * 2 * 60 * 60 * 1000)
    // 保存token
    cookie.save('ibroadcastappid', param.appid, {
      path: '/',
      expires: exp
    })
    cookie.save('ibroadcastaccesstoken', param.accesstoken, {
      path: '/',
      expires: exp
    })
    cookie.save('ibroadcastaccount', param.appid, {
      path: '/',
      expires: exp
    })
    // 获取成功，提交mutations处理数据
    // console.debug("AppIdLogin> param:%o", param);
    commit(types.APPID_LOGIN_SUCCESS, {param})
    let type = rootState.route.query.type || ''
    that.$router.push({ path: routeMap('/' + type) })
  },
  TokenLogin ({ commit, state, rootState }, that) {
    // 设置cookie过期时间
    const param = {
      appid: that.form.name,
      accesstoken: that.form.password
    }
    // console.debug("TokenLogin> param:%o", param);
    var exp = new Date()
    exp.setTime(exp.getTime() + 1 * 2 * 60 * 60 * 1000)
    // 保存token
    cookie.save('ibroadcastappid', param.appid, {
      path: '/',
      expires: exp
    })
    cookie.save('ibroadcastaccesstoken', param.accesstoken, {
      path: '/',
      expires: exp
    })
    cookie.save('ibroadcastaccount', param.appid, {
      path: '/',
      expires: exp
    })
    // 获取成功，提交mutations处理数据
    // console.debug("AppIdLogin> param:%o", param);
    commit(types.APPID_LOGIN_SUCCESS, {param})
    let type = 'press'
    that.$router.push({ path: routeMap('/' + type) })
  },

  /**
     * 退出登录
     */
  outLogin ({ commit }) {
    // 移除cookie
    cookie.remove('ibroadcasttoken', { path: '/' })
    cookie.remove('ibroadcastaccount', { path: '/' })
    cookie.remove('ibroadcastrole', { path: '/' })
    // cookie.remove('ibroadcastosspolicy', { path: '/' })
    // cookie.remove('ibroadcastosskeyid', { path: '/' })
    // cookie.remove('ibroadcastosssign', { path: '/' })
    cookie.remove('ibroadcastappid', { path: '/' })
    cookie.remove('ibroadcastaccesstoken', { path: '/' })
    sessionStorage.removeItem('userType')
    sessionStorage.removeItem('userName')
    // 清除tonken
    commit(types.USER_OUT_LOGIN)
    // 重定向登录页
    // window.location.pathname = '/login'
  }
}

const mutations = {
  [types.USER_LOGIN_SUCCESS] (state, { response, param }) {
    // console.debug("USER_LOGIN_SUCCESS> response:%o, param:%o", response, param);
    state.account = param.name
    state.token = response.data.token
    state.role = response.data.role
    // state.role = response.data.role
    // state.osspolicy = response.data.osspolicy
    // state.osskeyid = response.data.osskeyid
    // state.osssign = response.data.osssign
  },
  [types.APPID_LOGIN_SUCCESS] (state, {param}) {
    // console.debug("APPID_LOGIN_SUCCESS> param:%o", param);
    state.appid = param.appid
    state.accesstoken = param.accesstoken
    state.account = param.appid
  },
  [types.USER_OUT_LOGIN] (state) {
    state.account = null
    state.token = null
    state.role = null
    // state.osspolicy = null
    // state.osskeyid = null
    // state.osssign = null
    state.appid = null
    state.accesstoken = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js